import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Bug } from "lucide-react";
import { StateExtractionDiagnostic } from "./StateExtractionDiagnostic";
import { isInDevMode } from "@/config/featureFlags";

export const StateExtractionDiagnosticButton = () => {
  const [open, setOpen] = useState(false);

  // Only show in development AND when in dev mode
  if (!import.meta.env.DEV || !isInDevMode()) return null;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" size="sm" className="text-red-600 border-red-300 hover:bg-red-50">
          <Bug size={16} className="mr-2" />
          Diagnose State Extraction [DEV]
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-6xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>State Extraction Diagnostic [Development Only]</DialogTitle>
        </DialogHeader>
        <StateExtractionDiagnostic />
      </DialogContent>
    </Dialog>
  );
};
